import { AxiosResponse } from "axios";
import moment from "moment";
import { useDispatch } from "react-redux";
import { postRequest } from "helpers/axios";
import { API_ROUTES } from "helpers/constants/apis";
import {
  setCoordinateData,
  setRecordData,
  setSignData,
} from "../redux/slices/coordinatesReducer";
import { setSalesforceOrgId } from "../redux/slices/basicInfoReducer";
import {
  setTotalNoOfFields,
  setCompletedNoOfFields,
} from "../redux/slices/allFinalDataReducer";

interface UseCoordinatesFetcherProps {
  setIsFetchingCordinatesData: (val: boolean) => void;
  setIsAlreadySign: (val: boolean) => void;
}

export const useCoordinatesFetcher = ({
  setIsFetchingCordinatesData,
  setIsAlreadySign,
}: UseCoordinatesFetcherProps) => {
  const dispatch = useDispatch();

  const hasCompletedRequiredValue = (item: any) => {
    if (!item.isRequired || item.fieldType === "Signature") {
      return false;
    }

    if (item.fieldType === "Checkbox") {
      return item.value === true;
    }

    return item.value !== undefined && item.value !== null && String(item.value).trim() !== "";
  };

  const fetchingCordinates = async (
    id: string,
    uuidS: string
  ) => {
    try {
      const response: AxiosResponse = await postRequest(
        API_ROUTES.COMMON_FETCHCORDINATESDATA,
        false,
        {
          id,
          uuid_signatory: uuidS,
        }
      );

      const responseData = response?.data?.data;
      console.log("===> responseData of fetchingCordinates", responseData);
      if (!responseData) {
        setIsFetchingCordinatesData(false);
        return;
      }

      const actualData = responseData.data ? responseData.data : responseData;

      let coord = actualData?.coord || [];
      if (coord && coord.length > 0) {
        coord = coord.map((item: any) => ({
          ...item,
          pageNo: item.pageNo !== undefined ? item.pageNo : item.pageno,
          fieldType: item.fieldType !== undefined ? item.fieldType : item.fieldtype,
          eleId: item.eleId !== undefined ? item.eleId : item.ele_id,
          coordinateId: item.coordinateId !== undefined ? item.coordinateId : item.coordinateid,
          activeElementCoordinateId: item.activeElementCoordinateId !== undefined ? item.activeElementCoordinateId : item.activeelementcoordinateid,
          isRequired: item.isRequired !== undefined ? item.isRequired : item.isrequired,
          isUpdateFromSalesforce: item.isUpdateFromSalesforce !== undefined ? item.isUpdateFromSalesforce : item.isupdatefromsalesforce,
          mappingField: item.mappingField !== undefined ? item.mappingField : item.mappingfield,
        }));

        console.log("===> coord after update", coord);
      }
      const recordData = actualData?.recordData || {};
      const signData = actualData?.signData || [];

      if (coord && coord.length > 0) {
        const salesforceOrgId = coord[0].salesforce_org_id;
        dispatch(setSalesforceOrgId({ salesforceOrgId }));
      }

      let completedFieldCount = 0;

      if (coord && coord.length > 0) {
        coord.forEach((item: any) => {
          if (hasCompletedRequiredValue(item)) {
            completedFieldCount += 1;
          }
          if (item.fieldType === "Date") {
            item.value = item.value
              ? moment(item.value, "YYYY-MM-DD").format("DD-MM-YYYY")
              : "";
          }
        });
      }

      if (Object.keys(recordData).length > 0) {
        coord = coord.map((item: any) => {
          if (
            item.isUpdateFromSalesforce &&
            item.mappingField &&
            item.mappingField !== ""
          ) {
            if (
              recordData.hasOwnProperty(item.mappingField) &&
              recordData[item.mappingField] !== null
            ) {
              if (item.fieldType === "Date" && recordData[item.mappingField]) {
                item.value = moment(
                  recordData[item.mappingField],
                  "YYYY-MM-DD"
                ).format("MM-DD-YYYY");
              } else if (item.fieldType !== "Date") {
                item.value = recordData[item.mappingField];
              }
              if (hasCompletedRequiredValue(item)) {
                completedFieldCount += 1;
              }
            } else {
              item.value = item.fieldType === "Checkbox" ? false : "";
            }
          } else if (item.fieldType === "Date" && item.value) {
            item.value = moment(item.value, "YYYY-MM-DD").format("DD-MM-YYYY");
          }
          return item;
        });
      }

      const sortedPageNos: any = [
        ...(new Set(
          coord
            .map((item: any) => item.pageNo)
            .sort((a: number, b: number) => a - b)
        ) as any),
      ];

      const finalData: Array<Object> = [];
      sortedPageNos.forEach((currentPageNo: number) => {
        const data = coord
          .filter((item: any) => item.pageNo === currentPageNo)
          .sort((a: any, b: any) => a.y - b.y);
        finalData.push(...data);
      });

      dispatch(setCoordinateData({ allCoordinateData: finalData }));
      dispatch(setRecordData({ recordData }));
      dispatch(setSignData({ signData }));
      dispatch(setTotalNoOfFields({ allCoordinateData: finalData }));
      dispatch(setCompletedNoOfFields({ completedNoOfFields: completedFieldCount }));
      setIsFetchingCordinatesData(false);
    } catch (err: any) {
      if (
        err.response?.data?.msg?.toLowerCase() ===
        "sorry your signature is already done"
      ) {
        setIsAlreadySign(true);
      }
    } finally {
      setIsFetchingCordinatesData(false);
    }
  };

  return { fetchingCordinates };
};
